// App.js
import React, { useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.css'
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import ToolkitProvider from 'react-bootstrap-table2-toolkit'
import Card from 'react-bootstrap/Card'
import MySearch from './SearchDocumentation'

const table = ({
  data,
  dataImplicated,
  columns,
  id,
  titleTableDoc,
  search
}) => {
  const defaultSorted = [
    {
      dataField: 'name',
      order: 'desc'
    }
  ]
  const filterSearch = search
  const [dataTable, setDataTable] = data ? useState(data) : useState([])
  const [dataOriginal] = useState(data)
  const dataSeacrh = dataImplicated
  var count = 0
  return (
    <div className='App'>
      {dataTable.forEach((element) => {
        element.idTable = count++
      })}
      <ToolkitProvider
        bootstrap4
        keyField='Id'
        data={dataTable}
        columns={columns}
        search
      >
        {(props) => (
          <div>
            {filterSearch ? (
              <MySearch
                {...props}
                dataSeacrh={dataSeacrh}
                setDataTable={setDataTable}
                dataOriginal={dataOriginal}
              />
            ) : null}
            <hr />
            {titleTableDoc !== '' ? (
              <Card.Header style={{ background: 'gray', color: 'white' }}>
                {titleTableDoc}
              </Card.Header>
            ) : null}

            <BootstrapTable
              data={dataTable}
              columns={columns}
              defaultSorted={defaultSorted}
              pagination={paginationFactory({ sizePerPage: 5 })}
              {...props.baseProps}
            />
          </div>
        )}
      </ToolkitProvider>
    </div>
  )
}

export default table
